import React from 'react';
import { Modal } from 'antd';
import styled from 'styled-components';

import Button from 'shell/components/Button';
import Icon from 'shell/components/Icon';
import Text from 'shell/components/Text';

const ConfirmationModal = ({
    isOpen, // boolean
    destructive, // boolean
    title, // string
    content, // string
    confirmText = 'Confirm', // string
    cancelText = 'Cancel', // string
    onConfirm, // function
    onCancel, // function
    ...rest
}) => {
    return (
        <StyledModal closable={false} footer={null} visible={isOpen} zIndex={1200} {...rest}>
            <IconWrapper isDestructive={destructive}>
                <Icon color={'white'} kind={'error'} size={'12'} />
            </IconWrapper>
            <Text style={{ textAlign: 'center' }} color={destructive ? 'error' : 'primary'} variant={'subtitle3'}>
                {title}
            </Text>
            <StyledText style={{ textAlign: 'center' }} variant={'body2'}>
                {content}
            </StyledText>
            <ButtonContainer>
                <Button autoFocus color={'neutral'} variant={'tertiary'} onClick={onCancel}>
                    {cancelText}
                </Button>
                <Button color={destructive ? 'error' : 'primary'} variant={'secondary'} onClick={onConfirm}>
                    {confirmText}
                </Button>
            </ButtonContainer>
        </StyledModal>
    );
};

const StyledModal = styled(Modal)`
    & .ant-modal-content {
        border-radius: 12px;
        margin: auto;
        width: 280px;
    }

    & .ant-modal-body {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: ${(props) => props.theme.spacing(6)};
    }
`;

const StyledText = styled(Text)`
    margin: ${(props) => props.theme.spacing(2, 0, 6)};
`;

const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin-bottom: ${(props) => props.theme.spacing(2)};
    width: 24px;
    height: 24px;
    background-color: ${(props) =>
        props.isDestructive ? props.theme.palette.red.dark : props.theme.palette.primary['500']};
`;

const ButtonContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${(props) => props.theme.spacing(6)};
    width: 100%;
`;

export default ConfirmationModal;
